import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaScope } from "ecCom";

@observer
export default class ScopeItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaScope
        style={{ width: "100%" }}
        {...bindObj.bind()}
        value={toJS(bindObj.value)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
        isMobx
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/ScopeItem.js